import { Table } from 'antd';
import helpers from '../../../../../common/helpers/common';
import { DataTableSubmissionHistory } from '../../entity/Entity';
import { CM0016Handler } from '../handler/HandlerImpl';

type Props = {
    data: DataTableSubmissionHistory[];
    columns: any;
    title?: string;
    handler: CM0016Handler;
};

export const CM0016TableHasSummary = ({ data, columns, title, handler }: Props) => {
    return (
        <div className="table-bot">
            <Table
                columns={columns}
                dataSource={data}
                bordered
                title={() => title}
                pagination={false}
                summary={() => {
                    return (
                        <Table.Summary.Row
                            className="children-table-summary"
                            style={{
                                background: '#605BFF',
                                color: '#FFFFFF',
                            }}
                        >
                            <Table.Summary.Cell index={1} align="center">
                                <span>合計金額</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} align="center"></Table.Summary.Cell>
                            <Table.Summary.Cell index={3} align="center"></Table.Summary.Cell>
                            <Table.Summary.Cell index={4} align="center"></Table.Summary.Cell>
                            <Table.Summary.Cell index={5} align="center">
                                <span>{`${helpers.formatCurrency(
                                    handler?.dataSummary?.totalManualInput,
                                )}円`}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={6} align="center"></Table.Summary.Cell>
                            <Table.Summary.Cell index={7} align="center">
                                <span>{`${helpers.formatCurrency(
                                    handler?.dataSummary?.totalPayAmount,
                                )}円`}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={8} align="center">
                                <span>{`${helpers.formatCurrency(
                                    handler?.dataSummary?.totalActualCost,
                                )}円`}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={9} align="center"></Table.Summary.Cell>
                            <Table.Summary.Cell index={10} align="center"></Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
            />
        </div>
    );
};
